// Root entry point for the admin SPA.
//
// Reference: PRPs/phone_lookup_rtb_api_prp_v2.md §13.2 (page list), §16
// Phase G → G3.

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container #root not found");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
